import { NiveisStyled, NivelStyled } from "../Styles/Poco";
import arrowNivel from "../Assets/Icons/ArrowNivel.svg";
import { HomeContext } from "../Context/ContextHome";
import { useContext } from "react";

export const Nivel = ({ infoPoco, nivelPoco }) => {
  const { darkMode } = useContext(HomeContext);
  return (
    <NivelStyled>
      <NiveisStyled nivel={nivelPoco} darkmode={darkMode}>
        <div className="nivel">
          <span />
        </div>
        <div className="infoNivel">
          <p>{infoPoco}</p>
          <img src={arrowNivel} alt="" />
        </div>
      </NiveisStyled>
    </NivelStyled>
  );
};
